export enum TaskAction {

    UPDATE_STATUS = 1,
    CREATE_REMINDER = 2,
    EDIT_RECURRENCE = 3,
    DUPLICATE = 4,
    TIME_TRACKING = 5,
    SHARE_AS_TICKET = 6,

}